export default "__VITE_ASSET__eb24ad51__"